import { css, SerializedStyles } from '@emotion/react';
import { media } from '@opendoor/bricks/theme/novo/foundations/breakpoints';

export type InputSize = '200' | '300' | '400' | '600';
// Enforcing the len(sizeArray) <= 5
type InputSizeArray = [
  (InputSize | null)?,
  (InputSize | null)?,
  (InputSize | null)?,
  (InputSize | null)?,
  (InputSize | null)?,
];
export type InputSizeProp = InputSize | InputSizeArray;
export type SizeToStyleMap = { [key in InputSize]: SerializedStyles };

const INDEX_TO_MEDIA_QUERY = {
  1: media.largerThan.XS,
  2: media.largerThan.SM,
  3: media.largerThan.MD,
  4: media.largerThan.LG,
};

/*
  Goal is to support passing sizeVariant as an array for responsive sizes
  similar to how we use ChakraUI to pass props like marginTop={[0, 8, 12]}
*/
export const buildResponsiveStyling = (
  sizeToSerializedStyles: SizeToStyleMap,
  sizeVariant: InputSizeProp,
): SerializedStyles => {
  if (!Array.isArray(sizeVariant)) return sizeToSerializedStyles[sizeVariant];

  const styles: SerializedStyles = sizeVariant.reduce((stylesAcc, curSize, idx) => {
    if (!curSize) return stylesAcc;
    if (idx == 0) {
      return css`
        ${sizeToSerializedStyles[curSize]}
      `;
    }
    return css`
      ${stylesAcc}

      ${INDEX_TO_MEDIA_QUERY[idx]} {
        ${sizeToSerializedStyles[curSize]}
      }
    `;
  }, css``);

  return styles;
};
